export enum TransactionStatusType {
  '' = '',
  unreconciled = 'unreconciled',
  reconciled = 'reconciled',
  void = 'void',
}

export type TTransactionStatusType = keyof typeof TransactionStatusType;

export const TransactionStatusTypeValidator = (input: TTransactionStatusType) => {
  return input && (Object.values(TransactionStatusType) as string[]).includes(input);
};
